import { render } from "./popupBanner.vue?vue&type=template&id=b8afcc02&ts=true"
import script from "./popupBanner.vue?vue&type=script&lang=ts"
export * from "./popupBanner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__